'use client';

import styles from './Chip.module.css';
import { ChipProps } from './types';

const Chip = ({ label, onDelete }: ChipProps) => {
  return (
    <div className={styles.chipContainer}>
      <p className={styles.chip}>{label}</p>
      <span onClick={onDelete} className={styles.chipDelete} data-testid={`chip-${label}`} />
    </div>
  );
};

export default Chip;
